var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{model:{value:(_vm.isStyleValidComputed),callback:function ($$v) {_vm.isStyleValidComputed=$$v},expression:"isStyleValidComputed"}},[_vm._l((_vm.items),function(item,key){return [_c('v-row',{key:key,attrs:{"no-gutters":""}},[_vm._t(item.key)],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }